import React from 'react'
import { NextSeo } from 'next-seo'
import LegalTemplate from '@/src/components/Legal/LegalTemplate'

const LEGAL_CONTENT = `
# Terms of Promotion 

**Last Updated:** Dec 14, 2023

## **One Year Free Accessory Package Promotion**

Welcome to Orka, where we're dedicated to revolutionizing your hearing experience. This year, we're excited to announce our "One Year Free Accessory Package" promotion! The One Year Free Accessory Package promotion will allow you to have a one year supply of hearing accessories with your purchase, subject to the terms set forth herein.

## **Eligibility:**

This offer, available exclusively to all customers who purchase any of our eligible hearing aids during the promotional period, starting from [2023/12/18](12:00AM PST) until [2023/12/31](11:59PM PST) inclusive.

## **Accessory Package Includes:**

Each free Accessory Package includes the following items:
- Customized-size Domes X 3 pairs
- Wax Guards X 1 box (8 p)
- Cleaning Brush X 1 piece

Specific accessories may vary depending on your hearing aid model and personal choices.

## **Delivery Time:**

1. Upon registration for the "One-Year Free Accessory Package" promotion, your first free Accessory Package will be shipped after the shipment of your hearing aid purchase in accordance with the tentative shipment dates below. Please allow for a reasonable processing period to prepare and ship your package following the confirmation of your order.

2. The shipments of Accessory Packages are scheduled on a quarterly basis , with the following tentative shipment dates in 2024:
  - March 1st
  - June 1st
  - September 1st
  - December 1st

3. You should expect to receive your Accessory Package within [3-7 business days] following each tentative shipment date. However, please keep in mind that delivery timeframes may vary based on your geographic location and seasonal postal service conditions.

4. In the event of not receiving your Accessory Package as scheduled, please contact our customer support for assistance.

## **Policy and Restrictions:**

1. Upon purchasing a qualifying hearing aid during the promotional period, you will automatically be registered for the One Year Free Accessory Package promotion. You are entitled to 4 free Accessory Packages under the One Year Free Accessory Package promotion, and an additional initial set of accessories included in your purchased hearing aid. 

2. Your purchased hearing aid comes with an initial set of accessories included, which is expected to last between 1 to 3 months. Please note that this initial set is not counted as part of the One Year Free Accessory Package promotion.

3. Your free Accessory Packages will be shipped in accordance with the tentative shipment dates listed above on a quarter basis over the course of one year.

4. The Accessory Package and the One Year Free Accessory Package promotion are strictly non-transferable and cannot be exchanged for cash or any alternative offer.

5. In the event of a return or exchange of the hearing aid, it is hereby acknowledged that the accompanying One Year Free Accessory Package promotion shall be terminated. Moreover, it is explicitly stated that there is no requirement to return any Accessory Packages that have already been received by the customer in the event of a return or exchange of the purchased hearing aid.

6. The One Year Free Accessory Package promotion is subject to availability and while supplies last. Orka reserves the right to limit the number of participants eligible for the promotion based on inventory constraints. In the event that the supply of Accessory Packages becomes depleted during the promotional period or the one year period, Orka may, at its discretion, substitute the Accessory Package with an alternative of reasonable equal value. Participants acknowledge and agree that such substitution shall not entitle them to any additional compensation or recourse.

7. Orka reserves the right to modify, suspend, or cancel this promotion at any time in its sole discretion, with or without prior notice. 

8. The One Year Free Accessory Package promotion is provided on an "as-is" basis, without any warranties or representations, expressed or implied. Orka disclaims any liability for damages, losses, or expenses arising out of or in connection with the promotion, including but not limited to any delays, errors, or interruptions in the shipment or availability of the Accessory Packages. Orka shall not be held responsible for any dissatisfaction or issues related to the quality, performance, or compatibility of the Accessory Packages. Participants acknowledge and agree that their participation in the promotion is at their own risk.

## **Customer Support:**

Should you have any questions about the promotion or need assistance with your Accessory Package, please contact our customer support team at [support@hiorka.com](mailto:support@hiorka.com).
`

const TermsOfPromotion = () => {
  return (
    <>
      <LegalTemplate legalCopy={LEGAL_CONTENT} />
      <NextSeo title="Terms of Promotion | Orka - Hear what matters" />
    </>
  )
}

export default TermsOfPromotion
